import WelcomeContainer from '../../wrappers/WelcomeContainer'
import EmailGuy from '../../../ui-kit/static/images/stories/guy-sending-email.svg'
import {Link} from 'react-router-dom'

const EmailSentForm = () => {
  return (
    <WelcomeContainer
      title="Correo enviado"
      subtitle="No olvides revisar la bandeja de entrada o la carpeta de spam"
      graphic={EmailGuy}
    >
      <Link to="" className="button">
        Entendido
      </Link>
    </WelcomeContainer>
  )
}

export default EmailSentForm
